import InitialAnalysisList from "../../../components/screen/patientCare/patientCareInitialAnalysis/InitialAnalysisList";
import HOC from "../../../components/HOC";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const InitialAnalysisListPage = () => {
  return (
    <PageTemplate
      header="Initial Analysis"
      mainComponent={
        <ThemeProvider theme={theme}>
          <InitialAnalysisList />
        </ThemeProvider>
      }
      pageRole={18}
    />
  );
};

export default HOC(InitialAnalysisListPage);
